
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("d1G3o"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("7heir"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("d1G3o", function(module, exports) {

let $97bbfd5f86a5182d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $97bbfd5f86a5182d$var$load("953Uz"),
    $97bbfd5f86a5182d$var$load("fdsim")
]).then(()=>parcelRequire('jgOPc'));

});

parcelRegister("7heir", function(module, exports) {

let $54c535e3926d6bbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $54c535e3926d6bbb$var$load("d64xd"),
    $54c535e3926d6bbb$var$load("dq8fV"),
    $54c535e3926d6bbb$var$load("5k0cI"),
    $54c535e3926d6bbb$var$load("aM9Md"),
    $54c535e3926d6bbb$var$load("1f0Jg"),
    $54c535e3926d6bbb$var$load("aQ52k"),
    $54c535e3926d6bbb$var$load("90vep"),
    $54c535e3926d6bbb$var$load("hUbK8"),
    $54c535e3926d6bbb$var$load("2aRCy"),
    $54c535e3926d6bbb$var$load("l6q5O"),
    $54c535e3926d6bbb$var$load("5KHgm"),
    $54c535e3926d6bbb$var$load("fvc4H"),
    $54c535e3926d6bbb$var$load("kbQXh"),
    $54c535e3926d6bbb$var$load("iOfkQ"),
    $54c535e3926d6bbb$var$load("juqSe"),
    $54c535e3926d6bbb$var$load("jZ894"),
    $54c535e3926d6bbb$var$load("7TyQi"),
    $54c535e3926d6bbb$var$load("gXS72"),
    $54c535e3926d6bbb$var$load("5fGvF"),
    $54c535e3926d6bbb$var$load("kccW9"),
    $54c535e3926d6bbb$var$load("TfSzW"),
    $54c535e3926d6bbb$var$load("ceyL9"),
    $54c535e3926d6bbb$var$load("eeYoU"),
    $54c535e3926d6bbb$var$load("do0Fh"),
    $54c535e3926d6bbb$var$load("jL43T"),
    $54c535e3926d6bbb$var$load("7Hb14"),
    $54c535e3926d6bbb$var$load("4XoWv"),
    $54c535e3926d6bbb$var$load("kSgPY"),
    $54c535e3926d6bbb$var$load("jqoep"),
    $54c535e3926d6bbb$var$load("6wr18"),
    $54c535e3926d6bbb$var$load("59hV4"),
    $54c535e3926d6bbb$var$load("gJqWO"),
    $54c535e3926d6bbb$var$load("2la9m"),
    $54c535e3926d6bbb$var$load("9pQri"),
    $54c535e3926d6bbb$var$load("aMsb0"),
    $54c535e3926d6bbb$var$load("2PXrC"),
    $54c535e3926d6bbb$var$load("gcLWi"),
    $54c535e3926d6bbb$var$load("fsgrC"),
    $54c535e3926d6bbb$var$load("eqj21"),
    $54c535e3926d6bbb$var$load("3oAU3"),
    $54c535e3926d6bbb$var$load("a8glC"),
    $54c535e3926d6bbb$var$load("dRQNV"),
    $54c535e3926d6bbb$var$load("kwVVP"),
    $54c535e3926d6bbb$var$load("ccAQf"),
    $54c535e3926d6bbb$var$load("4x9Jx"),
    $54c535e3926d6bbb$var$load("ea3NB"),
    $54c535e3926d6bbb$var$load("1QpWP"),
    $54c535e3926d6bbb$var$load("4qBy5"),
    $54c535e3926d6bbb$var$load("6Vp6A"),
    $54c535e3926d6bbb$var$load("ffEVr"),
    $54c535e3926d6bbb$var$load("gzrfp"),
    $54c535e3926d6bbb$var$load("bwLq7"),
    $54c535e3926d6bbb$var$load("fH3TJ"),
    $54c535e3926d6bbb$var$load("Wowvf"),
    $54c535e3926d6bbb$var$load("2l8zo"),
    $54c535e3926d6bbb$var$load("ipLRb"),
    $54c535e3926d6bbb$var$load("5RCVQ"),
    $54c535e3926d6bbb$var$load("hhss7"),
    $54c535e3926d6bbb$var$load("aAWLw"),
    $54c535e3926d6bbb$var$load("7EorR"),
    $54c535e3926d6bbb$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.8c2f0206.js.map
